const NumberNavigation = {
  order: Infinity,
  run($$) {
    const $seatsHorizontalNavRulersNumber = $(
      "<div class='rulers-number __horizontal' />"
    )
      .appendTo($(".arena-workspace"))
      .hide();
    const $seatsVerticalNavRulersNumber = $(
      "<div class='rulers-number __vertical' />"
    )
      .appendTo($(".arena-workspace"))
      .hide();

    const $arenaWorkspace = $(".arena-workspace");

    const hoverHandler = function hoverHandler(event) {
      const $seat = $(event.target);
      if (event.type === "mouseenter") {
        const seat = $$.seats[`${$seat.data("row")}-${$seat.data("coll")}`];
        if (!seat) {
          return;
        }

        let leftOffset = 0;
        let topOffset = 0;

        if ($$.realScale === undefined || $$.realScale === 1) {
          leftOffset = $arenaWorkspace[0].scrollLeft;
          topOffset = $arenaWorkspace[0].scrollTop;
        } else {
          if ($arenaWorkspace[0].scrollTop > 0) {
            topOffset += $arenaWorkspace[0].scrollTop;
          }
        }

        topOffset -= $(".scene.__top").height() || 0;

        // const left = $seat.position().left / ($$.realScale || 1) - leftOffset;
        const left =
          $seat.position().left -
          leftOffset +
          $$.SEAT_WIDTH * ($$.realScale || 1);
        const top =
          $seat.position().top -
          topOffset +
          $$.SEAT_HEIGHT * ($$.realScale || 1);

        $seatsHorizontalNavRulersNumber
          .show()
          .text(seat.seat)
          .css({
            left,
          });
        $seatsVerticalNavRulersNumber
          .show()
          .text(seat.row)
          .css({
            top,
          });
      } else {
        $seatsHorizontalNavRulersNumber.hide();
        $seatsVerticalNavRulersNumber.hide();
      }
    };

    $$.$arena.on(
      "mouseenter mouseleave",
      ".seats-container > div",
      hoverHandler
    );
  },

  destroy($$) {
    $$.$arena.off("mouseenter mouseleave", ".seats-container > div");
  },
};

window.SectionNumberNavigation = NumberNavigation;

export default NumberNavigation;
